import React from 'react';
import styled from 'App/styled';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
import { useDispatch } from 'react-redux';
import { changeCurrentVariant } from 'shared/store/product/action';


interface VariantList {
  id: string,
  name: string,
}
interface DropdownHeaderProps {
  variantList: VariantList[];
  title: string;
  currentProductId: string;
  setDisableLazy: React.Dispatch<React.SetStateAction<boolean>>
};
const Wrapper = styled.div`
  display: inline-block;
  border-radius: ${({ theme }) => theme.borders.radius0};
  vertical-align: bottom;
  color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.92)};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borders.radius20};
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
  &::after { 
    content: "❯";
    position: absolute;
    transform: rotate(
      90deg
      );
    right: 8px;
    top: 5px;
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const SelectMenu = styled.select`
  border-radius: ${({ theme }) => theme.borders.radius0};
  color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.92)};
  ${({ theme }) => theme.typography.subTitleMedium};
  padding: 7px 24px 7px 2px;
  position: relative;
  width: auto;
  border: none;
  box-shadow: none;
  outline: none;
  background-color: transparent;
  -webkit-appearance: none;
  z-index: 2;
`;
const DropdownHeader = ({ variantList, title, currentProductId, setDisableLazy } :DropdownHeaderProps) => {
  const dispatch = useDispatch();
  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDisableLazy(true);
    const selectedIndex: number = parseInt(e.target.value);
    const selectedVariant = variantList[selectedIndex];
    dispatch(changeCurrentVariant(selectedVariant.id));
  };
  return (
    <Wrapper>
      <SelectMenu onChange={handleSelect} title={title}>
        <option>Select {title} ({variantList && variantList.length}) </option>
        {
          (variantList && variantList.map((item, index) => (
            <option key={item.id} value={index} selected={item.id == currentProductId}>{item.name}</option>
          )))
        }
      </SelectMenu>
    </Wrapper>
  );
};

export default DropdownHeader;
